import React from 'react';
export const Close: React.FC<any> = () => (
	<>
		<line
			x1="15.1213"
			y1="15"
			x2="29.15"
			y2="29.0287"
			strokeWidth="3"
			strokeLinecap="round"
		/>
		<line
			x1="1.5"
			y1="-1.5"
			x2="21.3396"
			y2="-1.5"
			transform="matrix(-0.707107 0.707107 0.707107 0.707107 31.1504 15)"
			strokeWidth="3"
			strokeLinecap="round"
		/>
	</>
);
